// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricE":"E_SaveElectricE__QCI1u"};